/* eslint-disable react/destructuring-assignment */
import {
  CalendarTodayRounded,
  CheckCircleRounded,
  ListAltRounded,
  SpellcheckRounded,
  UploadRounded,
} from '@mui/icons-material';
import { StepIconProps } from '@mui/material';
import { ColorLibStepIconRoot } from '../../DetalhesReuniao/styles';

export function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: <CalendarTodayRounded />,
    2: <ListAltRounded />,
    3: <CheckCircleRounded />,
    4: <UploadRounded />,
    5: <SpellcheckRounded />,
  };

  return (
    <ColorLibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorLibStepIconRoot>
  );
}
